<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="SendIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="confirmSendTemplate" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push("/editContact/" + this.params.data.id).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    confirmSendTemplate () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirm Resend',
        text: `You are about to resend msg template to "${this.params.data.name}"`,
        accept: this.sendTemplateMessage,
        acceptText: 'Send'
      })
    },
    sendTemplateMessage () {
      this.$store.dispatch("userManagement/sendTemplateMessage", this.params.data.id)
        .then(()   => { this.showSendSuccess() })
        .catch(err => { console.error(err)       })
    },
    /* async sendTemplateMessage (id) {
      try {
        const response = await this.$http.post(
          `${process.env.apiRobocob}/reestarClientFlow`,{
            cli_id : id
        });
        this.showSendSuccess()
        if(response.status == 1){
          this.showSendSuccess()
        }else{
          this.showError()
        }
      } catch (error) {
        console.error(error);
      }
    }, */
    deleteRecord () {
      this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
        .then(()   => { this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    showSendSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Sucessfully Resend',
        text: 'The template message was sent sucessfully!'
      })
    },
  }
  /* methods: {
    editRecord() {
      console.log(this.params.data.id)
      this.$router.push("/editContact/" + this.params.data.id).catch(() => {})

      
    },
    confirmSendTemplate () {
      console.log(this.params.data.name)
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirm Resend',
        text: `You are about to resend msg template to "${this.params.data.name}"`,
        accept: () => this.sendTemplateMessage(this.params.data.id),
        acceptText: 'Send'
      })
    },
    async sendTemplateMessage (id) {
      try {
        const response = await this.$http.post(
          `${process.env.apiRobocob}/reestarClientFlow`,{
            cli_id : id
        });
        //this.showSendSuccess()
        if(response.status == 1){
          this.showSendSuccess()
        }else{
          this.showError()
        }
      } catch (error) {
        console.error(error);
      }
    },
    showSendSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Sucessfully Resend',
        text: 'The template message was sent sucessfully!'
      })
    },
    confirmDeleteRecord () {
      console.log(this.params.data.name)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.name}"`,
        accept: () => this.deleteContact(this.params.data.id),
        acceptText: 'Delete'
      })
    },
    async deleteContact (id) {
      try {
        const response = await this.$http.post(
          `${process.env.apiRobocob}/deleteContactClient`,{
            cli_id : id
        });
        this.usersData = response.data;
        console.log('contactDeleted')
        this.$emit('contactDeleted');
        this.showDeleteSuccess()
      } catch (error) {
        console.error(error);
        this.showError()
      }
    },
    showDeleteSuccess () {
      
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    showError () {
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'An error Ocurred'
      })
    },
  } */
}
</script>
